import React from 'react';
import VideoThumbnailCard from '../../../../components/VideoThumbnailCard';
import { ShortContentView } from '../../../../../Pages/VideoPlayer/utils/queryParamsKeys';

const VideoGrid = ({
	videos,
	isLoggedIn,
	handlePlayerVideo,
	handleSubmit,
	handelSubmitPlaylist,
	savedVideoIds,
	selectedTags,
	setSelectedTags,
	modal,
	setModal,
	setVideoData,
	selectTagCallback
	
}) => {
	return (
		<div className="c-video_list">
			<div className="row m-0">
				{videos?.map((video, index) => (
					<div key={index} className="mb-2">
						<VideoThumbnailCard
							key={index}
							content={video}
							isLoggedIn={isLoggedIn}
							handlePlayerVideo={handlePlayerVideo}
							handelSubmitPlaylist={handelSubmitPlaylist}
							handleSaveUnsave={handleSubmit}
							savedVideos={savedVideoIds}
							modal={modal}
							setModal={setModal}
							setVideoData={setVideoData}
							titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
							selectTagCallback={selectTagCallback}
							selectedTags={selectedTags}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default VideoGrid;
